export const ANALYTICS = {
  EVENTS: {
    CLICKED_BUTTON: 'Clicked Button',
    CLICKED_LINK: 'Clicked Link',
    VIEWED_EHS_PAGE: 'Viewed EHS Page',
  },
};
